import { ChangeEvent, useState } from "react";

type PhoneInputProps = {
  label?: string;
  defaultValue?: string;
  onChange?: (value: { cleanedValue: string; error: string }) => void;
};

const PhoneInput = ({
  label = "Phone",
  defaultValue = "",
  onChange,
}: PhoneInputProps) => {
  const [phone, setPhone] = useState(defaultValue);
  const [error, setError] = useState("");

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const cleanedValue = value.replace(/\D/g, ""); // Remove non-numeric characters

    // Format the value
    let formattedValue = cleanedValue;
    if (cleanedValue.length > 0) {
      formattedValue = `(${cleanedValue.slice(0, 3)}`;
      if (cleanedValue.length > 3) {
        formattedValue += `) ${cleanedValue.slice(3, 6)}`;
      }
      if (cleanedValue.length > 6) {
        formattedValue += `-${cleanedValue.slice(6, 10)}`;
      }
    }

    // Set phone and error states
    setPhone(cleanedValue);

    let errorMessage = "";
    if (cleanedValue.length === 0) {
      errorMessage = "Phone number is required";
    } else if (cleanedValue.length !== 10) {
      errorMessage = "Phone number must be 10 digits";
    }

    setError(errorMessage);

    // Trigger parent callback if provided
    if (onChange) {
      onChange({ cleanedValue, error: errorMessage });
    }
  };

  return (
    <div className="relative mt-1 rounded-md shadow-sm">
      <label
        htmlFor="phone"
        className="block text-sm font-medium text-gray-700"
      >
        {label}
        <span className="text-red-500">*</span>
      </label>
      <div className="relative">
        <div className="absolute inset-y-0 left-0 flex items-center">
          <span className="h-full border-r border-gray-300 bg-gray-100 px-3 py-2 text-gray-500 sm:text-sm">
            +1
          </span>
        </div>
        <input
          type="tel"
          name="phone"
          id="phone"
          className={`block w-full rounded-md border pl-16 ${
            error ? "border-red-500" : "border-gray-300"
          } shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm`}
          placeholder="(xxx) xxx-xxxx"
          value={phone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3")}
          onChange={handleInputChange}
          maxLength={14}
          required
        />
      </div>
      {error && <div className="mt-1 text-sm text-red-500">{error}</div>}
    </div>
  );
};

export default PhoneInput;
